import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import mycalendar from "./mycalendar";

const Mycalendar = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
		
		
			<Route path={`${match.url}/my-calendar`} component={mycalendar} />
			<Route path={`${match.url}`} component={mycalendar} />
			<Redirect to="/error" />
        </Switch>
    </div>
);
export default Mycalendar  ;